import { Post, Posts} from '../../PrivateComponents';
//import Profile1 from '../../pages/user/profile2';

import DashboardMainPage from '../../pages/dashboard/index'

import UserMainPage from '../../pages/users/index'
import UserDetailPage from '../../pages/users/detail'
import UserIdentityPage from '../../pages/users/identity'
import UserResetPasswordPage from '../../pages/users/resetPassword'
import UserCourseMainPage from '../../pages/userCourses/index'
import UserCourseDetailPage from '../../pages/userCourses/detail'

import CourseMainPage from '../../pages/courses/index'
import CourseDetailPage from '../../pages/courses/detail'

import OrganiserMainPage from '../../pages/organisers/index'
import OrganiserDetailPage from '../../pages/organisers/detail'

import MarketingMainPage from '../../pages/marketings/index'
import MarketingDetailPage from '../../pages/marketings/detail'

import TrainerMainPage from '../../pages/trainers/index'
import TrainerDetailPage from '../../pages/trainers/detail'

import OrderMainPage from '../../pages/orders/index'
import OrderDetailPage from '../../pages/orders/detail'

import FeedbackMainPage from '../../pages/feedbacks/index'

import ConcentrationMainPage from '../../pages/concentrations/index'
import ConcentrationDetailPage from '../../pages/concentrations/detail'

export default {
    Profile: {
        component: DashboardMainPage,
        path: '/'
    },
    User: {
        component: UserMainPage,
        path: '/users'
    },
    UserDetailPage: {
        component: UserDetailPage,
        path: '/users/:id'
    },
    UserIdentityPage: {
        component: UserIdentityPage,
        path: '/users/:id/identity'
    },
    UserResetPasswordPage: {
        component: UserResetPasswordPage,
        path: '/users/:id/resetPassword'
    },
    UserCourse: {
        component: UserCourseMainPage,
        path: '/users/:id/courses'
    },
    UserCourseDetailPage: {
        component: UserCourseDetailPage,
        path: '/users/:id/courses/:userCourseId'
    },
    Course: {
        component: CourseMainPage,
        path: '/courses'
    },
    CourseDetails:{
        component: CourseDetailPage,
        path: '/courses/:id'
    },
    Order: {
        component: OrderMainPage,
        path: '/orders'
    },
    OrderDetails:{
        component: OrderDetailPage,
        path: '/orders/:id'
    },
    Feedback: {
        component: FeedbackMainPage,
        path: '/feedbacks'
    },
    Organiser: {
        component: OrganiserMainPage,
        path: '/organisers'
    },
    OrganiserDetails: {
        component: OrganiserDetailPage,
        path: '/organisers/:id'
    },
    Marketing: {
        component: MarketingMainPage,
        path: '/marketings'
    },
    MarketingDetails: {
        component: MarketingDetailPage,
        path: '/marketings/:id'
    },
    Trainer: {
        component: TrainerMainPage,
        path: '/organisers/:organiserId/trainers'
    },
    TrainerDetails: {
        component: TrainerDetailPage,
        path: '/organisers/:organiserId/trainers/:trainerId'
    },
    Concentration: {
        component: ConcentrationMainPage,
        path: '/concentrations'
    },
    ConcentrationDetails: {
        component: ConcentrationDetailPage,
        path: '/concentrations/:id'
    },
    // Profile1: {
    //     component: Profile1,
    //     path: '/profile'
    // },
};